import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import { convertToBase64 } from "../../utils/Common";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import JSZip from "jszip";
import toastNotify from "../../utils/ToastNotify";
import { getImageMimeType } from "../../utils/Helper";
import { Card, Row, Col, Badge, Button, } from "react-bootstrap";
import SelectField from "../../componants/textField/SelectField";
import { handleLoader } from "../../redux/reducers/layout";
import { useDispatch } from "react-redux";
import { BiFileBlank, BiHomeAlt, BiLeftArrowAlt, BiLink, BiRedo, BiShare, BiTrash, BiUndo } from "react-icons/bi";


const TicketView = () => {
  const [multiFile, setMultiFile] = useState([]);
  const [ticketPost, setTicketPost] = useState([]);
  const [replySection, setReplySection] = useState(false);
  const [toggleDescription, setToggleDescription] = useState({});
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const dispatch = useDispatch();
  const { state } = useLocation();


  const handleDataToggle = (id) => {
    if (currentActiveId !== null) {
      setToggleDescription((preState) => ({ ...preState, [currentActiveId]: false }));
    };
    setCurrentActiveId(id);
    setToggleDescription((preState) => ({ ...preState, [id]: !toggleDescription[id] }));
  };

  const removeTag = (data) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = data;
    return tempDiv.textContent || tempDiv.innerText
  }


  const navigate = useNavigate();
  const editorRef = useRef();
  const attanchmentRef = useRef(null);

  const editorConfiguration = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "undo",
        "redo",
      ],
    },
  };

  const handleMultiFile = (e) => {
    const files = e.target.files;
    if (files.length + multiFile.length > 5) {
      return toastNotify("You can only upload up to 5 files", "error");
    }

    // var fileArray = [];
    let fileArray = [...multiFile]; // Create a copy of the existing files

    // var mimeData: any;
    if (files.length > 0) {
      Array.from(files).forEach((file) => {
        const fileSize = (file.size / 1048576).toFixed(2); // Convert file size to MB
        const reader = new FileReader();
        reader.onloadend = () => {
          const mimeType = getImageMimeType(reader);

          if (mimeType === "unknown") {
            return toastNotify("Invaid file format", "error");
          } else if (Number(fileSize) > 5) {
            // Check if the file size is greater than 5 MB
            return toastNotify("File size must be less than 5 MB", "error");
          }

          fileArray.push(file);
          // setMultiFile(fileArray);

          // Update the state only once after all files are processed
          if (fileArray.length === files.length + multiFile.length) {
            setMultiFile(fileArray);
          }
        };
        reader.onerror = () => {
          toastNotify("Error reading file", "error");
        };
        reader.readAsArrayBuffer(file);
      });
    }
  };

  const attachfiles = () => {
    attanchmentRef.current.click();
  };

  // in thisfunction convert zip and base64
  const generateZipFile = async () => {
    const zip = new JSZip();
    if (multiFile.length > 0) {
      multiFile.forEach((items) => {
        zip.file(items.name, items);
      });
      const content = await zip.generateAsync({ type: "blob" });
      const base64 = await convertToBase64(content);
      return base64.split(",")[1];
    } else {
      return "";
    }
  };

  // Function to get the selected file size
  const getSelectedFileSize = () => {
    if (multiFile.length > 0) {
      const fileSize = multiFile.reduce((acc, file) => acc + file.size, 0);
      return fileSize;
      // return (fileSize / 1048576).toFixed(2) + " MB";
    } else {
      return 0;
    }
  };

  // const fetchTicketStatus = async () => {
  //   try {
  //     // setIsLoading(true);
  //     const data = { STATUS_FOR: "C" };
  //     const config = {};
  //     await makeRequest("POST", urls.getTicketStatus, data, config).then(
  //       (result) => {
  //         if (result.STATUS === "0") {
  //           const response = result.RESPONSE;
  //           setTicketStatus(response);
  //         } else if (result.STATUS !== "0") {
  //         }
  //       }
  //     );
  //   } catch (error) {
  //     // submitErrorLogToApi(error);
  //   } finally {
  //     // setIsLoading(false);
  //   }
  // };

  async function handleTicketSubmit(val, resetForm) {
    try {
      dispatch(handleLoader(true));
      const getBase64 = await generateZipFile();
      const payload = {
        TICKET_ID: state.response.TICKET_ID,
        DESCRIPTION: val.description,
        FILE_B64: getBase64,
        FILE_SIZE: getSelectedFileSize().toString(),
      };
      const config = {};
      const result = await makeRequest(
        "POST",
        urls.setTicketPost,
        payload,
        config
      );
      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        // Clear CKEditor content
        if (editorRef.current && editorRef.current.editor) {
          editorRef.current.editor.setData("");
        }

        resetForm({ values: { discription: "" }, errors: {} });
        setMultiFile([]); // Clear the multiFile state
        fetchTicketPost(); // Fetch updated ticket posts
        setReplySection(!replySection);
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toastNotify("An unexpected error occurred. Please try again.", "error");
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function handleStatusSubmit(val, resetForm) {
    try {
      dispatch(handleLoader(true));
      const payload = {
        TICKET_ID: state.response.TICKET_ID,
        STATUS_CD: val.statusValue,
      };
      const config = {};
      await makeRequest("POST", urls.setTicketStatus, payload, config).then(
        (result) => {
          if (result.STATUS === "0") {
            toastNotify(result.MESSAGE, "success");
            resetForm();

            fetchTicketPost();
            setReplySection(!replySection);
          } else if (result.STATUS !== "0") {
            toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function fetchTicketPost() {
    try {
      dispatch(handleLoader(true));
      const data = { TICKET_ID: state.response.TICKET_ID };
      const result = await makeRequest("POST", urls.getTicketPost, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setTicketPost(response);
      } else if (result.STATUS !== "0") {
      }
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  // async function fetchTicketDtl() {
  //   try {
  //     const data = { TICKET_ID: state.TICKET_ID };
  //     setIsLoading(true);
  //     const result = await makeRequest("POST", urls.getTicketDtl, data, {});
  //     if (result.STATUS === "0") {
  //       const response = result.RESPONSE;
  //       setTicketDtl(response);
  //     } else if (result.STATUS !== "0") {
  //     }
  //   } catch (error) {
  //     // submitErrorLogToApi(error);s
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  const handleDownload = async (value) => {
    try {
      dispatch(handleLoader(true));
      const payload = {
        DTL_TRAN_CD: value.TRAN_CD,
        TICKET_ID: value.TICKET_ID,
      };
      const result = await makeRequest(
        "POST",
        urls.downloadTicketAttach,
        payload,
        {}
      );
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0].FILE_DOWNLOAD_PATH;
        const link = document.createElement("a");
        link.href = response; // The URL of the file
        link.download = `${value.SUBJECT}-${value.TICKET_ID}-attachments.zip`;
        document.body.appendChild(link);
        link.click(); // Trigger the download
        link.remove(); // Remove the link element after the click
      }
    } catch (error) {
      // submitErrorLogToApi(error);
      console.error("Error fetching data:", error);
    } finally {
      dispatch(handleLoader(false));
    }
  };

  useEffect(() => {
    // fetchTicketStatus();
    fetchTicketPost();
  }, []);

  const ticketStatusNew = [
    {
      TRAN_CD: "1",
      STATUS_FOR: "B",
      STATUS_NM: "RE-OPEN",
      STATUS_TYPE: "R",
    },
    {
      TRAN_CD: "2",
      STATUS_FOR: "B",
      STATUS_NM: "CLOSED",
      STATUS_TYPE: "C",
    },
  ];


  const updateTicketPostStatus = async (values, resetForm) => {
    if (values.description !== '' && values.statusValue !== '') {
      await handleTicketSubmit(values, resetForm);
      await handleStatusSubmit(values, resetForm)
    } else if (values.description !== '') {
      await handleTicketSubmit(values, resetForm);
    } else if (values.statusCD !== '') {
      await handleStatusSubmit(values, resetForm);
    } else {
      toastNotify("Please fill message or status.", 'error');
    }
  }

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <>
        <div className="row date-time container-top">
          <div className="col-lg-12 col-md-12 col-12 mb-2">
            <div className="d-flex justify-content-between">
              <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
                <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                  Dashboard
                </NavLink>
                <span className="text-secondary d-none d-md-inline"> / </span>
                <NavLink to="/support" className="text-secondary d-none d-md-inline">
                  {state.response.CLASSIFICATION === "Q" ? "Inquiry" : "Support"} /
                </NavLink>
                <span className="navigation-header-text ps-1 ">
                  {state.response.CLASSIFICATION === "Q" ? "Inquiry" : "Ticket"} Detail
                </span>
              </div>
              <div
                className="btn btn-sm btn-warning"
                onClick={() => navigate(state.response.CLASSIFICATION === "Q" ? "/product-inquiry" : "/support")}
              >
                <BiLeftArrowAlt className="text-lg me-1" />
                Back
              </div>
            </div>
          </div>
        </div>

        <Card>
          <Card.Body className="py-0">
            <Row className="TicketDetailsContainer">
              <Col md={3} className="p-3 ticketDetails">

                <div className="d-grid gap-3">
                  <div>
                    <div className="text-slate-500 text-xs">{state.response.CLASSIFICATION === "Q" ? "Inquiry" : "Ticket"} Created Date</div>
                    <div className="text-sm">{state.response.CREATE_DT}</div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">{state.response.CLASSIFICATION === "Q" ? "Inquiry" : "Ticket"} Id</div>
                    <div className="text-sm">#{state?.response?.TICKET_ID}</div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Status</div>
                    <div>
                      {state.response.STATUS_CD === 'O' && <Badge bg="success">Open</Badge>}
                      {state.response.STATUS_CD === 'C' && <Badge bg="danger">Closed</Badge>}
                      {state.response.STATUS_CD === 'P' && <Badge bg="primary">Pending</Badge>}
                      {state.response.STATUS_CD === 'I' && <Badge bg="warning">In-Process</Badge>}
                      {state.response.STATUS_CD === 'R' && <Badge bg="success">Re-Open</Badge>}
                      {state.response.STATUS_CD === 'A' && <Badge bg="info">Assigned</Badge>}
                    </div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Product</div>
                    <div className="text-sm">{state.response.PRODUCT_NM}</div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Classification</div>
                    <div className="text-sm">
                      {state.response.CLASSIFICATION === 'Q' && 'Inquiry'}
                      {state.response.CLASSIFICATION === 'C' && 'Support'}
                      {state.response.CLASSIFICATION === 'O' && 'Other'}
                    </div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Priority</div>
                    <div>
                      {state.response.PRIORITY === 'H' && <Badge bg="danger">High</Badge>}
                      {state.response.PRIORITY === 'N' && <Badge bg="warning">Normal</Badge>}
                      {state.response.PRIORITY === 'L' && <Badge bg="success">Low</Badge>}
                    </div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Last Assign To</div>
                    <div className="text-sm">{state.response.LAST_ASSIGN_TO_NM}</div>
                  </div>

                  <div>
                    <div className="text-slate-500 text-xs">Last Activity</div>
                    <div className="text-sm">{state.response.LAST_ACTIVITY_DT}</div>
                  </div>

                </div>
              </Col>

              <Col md={9} className="p-3 ticketDetails border-0">
                <div className="d-flex align-items-center">
                  <h5
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      width: "75%",
                    }}
                    className="mb-0 text-base"
                  >
                    {state.response.SUBJECT}
                  </h5>
                  {/* {state.response.TicketActive === "Y" ?
                    <>
                      {userData.TicketPermanentCloseStatus !== "B" && userData.TicketPermanentCloseStatus !== "A" ? */}
                  <div className="ms-auto">
                    <Button
                      type="button"
                      variant={`${replySection ? 'outline-secondary' : "primary"} `}
                      className="btn-sm"
                      onClick={() => {
                        setReplySection(!replySection);
                      }}
                    >
                      {replySection ? <>Back</> :
                        <><BiShare className="me-1" /> Reply</>
                      }
                    </Button>
                  </div>
                  {/* : ""}
                    </>
                    : ""} */}
                </div>
                <hr className="mb-0" />

                <div>
                  {/* reply part start */}
                  {replySection && (
                    <div className="border-bottom p-3">
                      <Formik
                        initialValues={{ description: '', statusValue: "", statusLabel: "", attachFile: [] }}
                        onSubmit={async (values, { resetForm }) => {
                          updateTicketPostStatus(values, resetForm)
                        }}
                      >
                        {({ values, handleSubmit, setFieldValue, touched, errors }) => {
                          return (
                            <form onSubmit={handleSubmit}>
                              <div className="d-flex">
                                <div
                                  style={{ width: 40, height: 40 }}
                                  className="border border-primary text-primary rounded-circle d-flex justify-content-center align-items-center text-uppercase me-2"
                                >
                                  {state.response.CREATE_BY_NM.charAt(0)}
                                </div>

                                <Row className="w-100" >
                                  <Col md={12}>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      config={editorConfiguration}
                                      name="description"
                                      ref={editorRef}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setFieldValue("description", data);
                                      }}
                                    />
                                    <small className="text-danger">
                                      {errors.description &&
                                        touched.description &&
                                        errors.description}
                                    </small>
                                  </Col>

                                  <Col md={6} className="mt-3">
                                    <SelectField
                                      name="status"
                                      required
                                      options={ticketStatusNew.map((items) => ({
                                        value: items.STATUS_TYPE, label: items.STATUS_NM, StatusType: items.StatusType, StatusFor: items.StatusFor
                                      }))}
                                      placeholder='Status'
                                      onChange={(e) => { setFieldValue("statusValue", e?.value); setFieldValue("statusLabel", e?.label) }}
                                    />
                                  </Col>

                                  <Col md={6}></Col>

                                  <Col md={6} className='mt-3'>
                                    <input
                                      type="file"
                                      name="attachFile"
                                      multiple
                                      className="d-none"
                                      ref={attanchmentRef}
                                      accept={`.png,.jpeg,.jpg,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.eml,.msg`}
                                      onChange={(e) => {
                                        const selectFiles = e.target.files;
                                        setFieldValue('attachFile', selectFiles);
                                        handleMultiFile(e)
                                      }}
                                    />

                                    <span
                                      className="d-flex align-items-center"
                                      onClick={attachfiles}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div
                                        className="border rounded-circle d-flex justify-content-center align-items-center me-2 border-primary text-primary"
                                        style={{ width: 35, height: 35 }}
                                      >
                                        <BiLink />
                                      </div>
                                      <div>
                                        <h5 className="text-sm mb-0">
                                          Attach a file
                                        </h5>
                                        <div className="text-xs text-slate-500">Up to 5 MB</div>
                                      </div>
                                    </span>

                                    <div className='mt-3'>
                                      {multiFile.map((file, id) => {
                                        const fileSize = file.size >= 1024 ? (file.size / 1048576).toFixed(2) + " MB" : (file.size / 1024).toFixed(2) + " KB"
                                        return (
                                          <div
                                            key={id}
                                            className="d-flex align-items-center mt-3"
                                          >
                                            {file.type === "image" ?
                                              <div
                                                className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                                style={{ width: 35, height: 35 }}
                                              >
                                                <img src={file ? URL.createObjectURL(file) : ""} alt={file.name} className="w-100 h-100 rounded-circle" />
                                              </div>
                                              :
                                              <div
                                                className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                                style={{ width: 35, height: 35 }}
                                              >
                                                <BiFileBlank />
                                              </div>
                                            }
                                            <div>
                                              <h5 title={file.name}
                                                className="text-sm mb-1"
                                                style={{
                                                  width: "290px",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap"
                                                }}>{file.name}</h5>
                                              <div className="text-xs text-slate-500">File Size : {fileSize}</div>
                                            </div>
                                            <Button variant='outline-danger' className='rounded-circle btn-sm ms-auto'
                                              style={{ width: 35, height: 35 }}
                                              onClick={() => {
                                                let newValue = [...values.attachFile];
                                                newValue.splice(id, 1);
                                                setFieldValue('attachFile', newValue);

                                                let selectedFile = [...multiFile];
                                                selectedFile.splice(id, 1);
                                                setMultiFile(selectedFile);
                                              }}>
                                              <BiTrash />
                                            </Button>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </Col>

                                  <Col md={12}>
                                    <div className="mt-3">
                                      <Button type="submit" variant="primary" className="btn-sm">
                                        Status & Post Update
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </form>
                          )
                        }}
                      </Formik>
                    </div>
                  )}

                  {/* reply part end */}

                  <div className="border rounded mt-3">
                    {ticketPost.map((item, id) => {
                      return (
                        <div className="border-bottom p-2" key={id}>
                          <div
                            className="d-flex"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDataToggle(id)}
                          >
                            <div
                              style={{ width: 40, height: 40 }}
                              className={`border rounded-circle d-flex justify-content-center align-items-center me-2 ${item.REPLAY_FLAG === "A" ? "border-success text-success" : "border-warning text-warning"}  text-uppercase`}
                            >

                              {item.REPLAY_FLAG === "A" ?
                                <span className="text-success">
                                  <BiRedo className="text-xl" />
                                </span> : <span className="text-warning">
                                  <BiUndo className="text-xl" />
                                </span>}
                            </div>
                            <div>
                              <h2 className="text-base mb-0 text-capitalize">{item.REPLAY_BY_NM}</h2>
                              <div className="text-xs text-slate-500">{item.LAST_ACTIVITY_DT}</div>
                            </div>
                          </div>

                          <div className="mt-3 Pop-up ">
                            {toggleDescription[id] ? (
                              <>

                                <div className='ql-editor'>
                                  <div dangerouslySetInnerHTML={{ __html: item.DESCRIPTIONS }} />
                                </div>

                                {item.FILE_STATUS === 'Y' &&
                                  <div className="my-3">
                                    <div>
                                      <div className='zip-download-btn text-sm d-flex align-items-center justify-content-center' onClick={() => handleDownload(item)}><span>Download</span><span>ZIP File</span></div>
                                    </div>
                                  </div>
                                }
                              </>
                            ) : (
                              <p
                                style={{
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  width: "100%",
                                }}
                                className='text-sm mb-0'
                              >
                                {removeTag(item.DESCRIPTIONS)}
                              </p>
                            )}
                          </div>
                        </div>
                      )
                    })}
                  </div>

                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    </div >
  );
};

export default TicketView;
